import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const GallNav = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [hoverHome, setHoverHome] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 576);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 10);
    const onResize = () => setIsMobile(window.innerWidth <= 576);

    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  // Responsive background + shadow
  const navbarStyle = {
    backgroundColor: isScrolled ? 'rgba(33,34,35,0.85)' : 'rgba(33,34,35,0.62)',
    backdropFilter: 'blur(10px)',
    transition: '0.3s ease',
    boxShadow: isScrolled ? '0 4px 20px rgba(0,0,0,0.25)' : 'none',
    padding: isMobile ? '8px 0' : '10px 0',
  };

  // Responsive button pill
  const buttonContainer = {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'rgba(91, 95, 95, 0.86)',
    borderRadius: '22px',
    padding: isMobile ? '4px 10px' : '6px 14px',
  };

  // Responsive text & underline
  const navLinkStyle = {
    position: 'relative',
    fontSize: isMobile ? '0.8rem' : '0.9rem',
    textTransform: 'uppercase',
    fontWeight: 600,
    color: hoverHome ? '#ffc107' : '#fff',
    textDecoration: 'none',
    transition: 'color 0.3s ease',
    paddingBottom: '3px',
  };

  const underline = {
    content: '""',
    position: 'absolute',
    left: 0,
    bottom: 0,
    height: '2px',
    width: hoverHome ? '100%' : '0%',
    backgroundColor: '#ffc107',
    transition: 'width 0.3s ease',
  };

  return (
    <nav className='navbar navbar-dark fixed-top' style={navbarStyle}>
      <div className='container d-flex justify-content-between align-items-center px-2'>
        {/* LOGO + BRAND */}
        <Link
          to='/'
          className='navbar-brand d-flex align-items-center text-light fw-semibold mb-0'
          style={{ fontSize: isMobile ? '0.9rem' : '1rem' }}
        >
          <img
            src='img/logo.png'
            width={isMobile ? '38' : '46'}
            height={isMobile ? '38' : '46'}
            alt='logo'
            className='rounded-circle me-2 border border-warning'
          />
          Pravin BirdNetting Pune
        </Link>

        {/* ONLY HOME BUTTON */}
        <div style={buttonContainer}>
          <Link
            to='/'
            style={navLinkStyle}
            className='position-relative'
            onMouseEnter={() => setHoverHome(true)}
            onMouseLeave={() => setHoverHome(false)}
          >
            Home
            <span style={underline}></span>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default GallNav;
